import { connect } from 'react-redux'
import { IDailyTripLogReq, IStoreState, ITripLogReq } from '../../types'
import { ModivcareTripLogPDFNew } from '../../components/services/view/pdfs/ModivcareTripLogPDFNew'
import { getTripLogPerServiceAndDateRange } from '../../state/actions/trips'
export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    isFetching: state.trips.isFetching,
    dailyTripLogs: state.trips.dailyTripLogs
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getTripLogPerServiceAndDateRange: (params: ITripLogReq) => dispatch(getTripLogPerServiceAndDateRange(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModivcareTripLogPDFNew)



// WEBPACK FOOTER //
// ./src/containers/services/ModivcareTripLogPDFNew.ts